import React, { useEffect, useState } from 'react';
import { TextField, Autocomplete } from '@mui/material';
import { FormikTouched } from 'formik/dist/types';
import { useAuthContext } from '../../../../contexts/authContext';

type Props = {
    label: string;
    name: string;
    data?: any[];
    size?: 'small' | 'medium' | undefined;
    margin?: 'dense' | 'normal' | 'none';
    required?: false | boolean;
    value?: string | undefined;
    touched?: boolean | FormikTouched<any> | FormikTouched<any>[] | undefined;
    errors?: any;
    disabled?: boolean;
    onChangeValue: (event: string) => void;
    inputValueEnabled?: false | boolean;
    onInputValue?: any;
    reasonEnabled?: false | boolean;
    onReason?: any;
    getOptionLabel?: (option: any) => string;
    defineValue?: string | undefined;
};

const AutocompleteField = ({
    label,
    name,
    data,
    size,
    margin,
    required,
    touched,
    errors,
    value,
    disabled,
    onChangeValue,
    onInputValue,
    reasonEnabled,
    onReason,
    inputValueEnabled,
    getOptionLabel,
    defineValue,
}: Props) => {
    //onChangeValue Formik
    //The variable autocompleteFormik must be equal to the variable name of the formik
    //onChangeValue={(value) => formik.setFieldValue('autocompleteFormik', value)}

    const { modeTheme } = useAuthContext();
    const [inputValue, setInputValue] = useState<any | null>('');
    const [valueItem, setValueItem] = useState<any | null>(value);

    useEffect(() => {
        if (value && data && data.length > 0 && value !== valueItem?.id) {
            setValueItem(data?.find((item) => item.id === value) || null);
        }
    }, [value, data]);

    return (
        <>
            <Autocomplete
                id="combo-box-demo"
                options={data || []}
                disabled={disabled}
                getOptionLabel={
                    !getOptionLabel
                        ? (option) => option.name || ''
                        : getOptionLabel
                }
                value={valueItem}
                onChange={(_: any, newValue: any) => {
                    setValueItem(newValue);
                    if (newValue) {
                        onChangeValue(
                            defineValue === 'value'
                                ? newValue.name
                                : newValue.id
                        );
                    }
                }}
                inputValue={inputValue || ''}
                onInputChange={(
                    _: any,
                    newInputValue: string | null,
                    reason
                ) => {
                    setInputValue(newInputValue);
                    if (reasonEnabled) {
                        onReason(reason);
                    }
                    if (inputValueEnabled) {
                        onInputValue(newInputValue);
                    }
                }}
                filterSelectedOptions
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={label}
                        name={name}
                        size={size}
                        margin={margin}
                        required={required}
                        helperText={touched ? errors : ''}
                        error={touched && Boolean(errors)}
                        sx={{
                            '& label.Mui-focused': {
                                color:
                                    modeTheme === 'darkMode'
                                        ? 'primary.contrastText'
                                        : 'primary.main',
                            },
                            '& .MuiInput-underline:after': {
                                borderBottomColor:
                                    modeTheme === 'darkMode'
                                        ? 'primary.contrastText'
                                        : 'primary.main',
                            },
                            '& .MuiFilledInput-underline:after': {
                                borderBottomColor:
                                    modeTheme === 'darkMode'
                                        ? 'primary.contrastText'
                                        : 'primary.main',
                            },
                            '& .MuiOutlinedInput-root': {
                                '&.Mui-focused fieldset': {
                                    borderColor:
                                        modeTheme === 'darkMode'
                                            ? 'primary.contrastText'
                                            : 'primary.main',
                                },
                            },
                        }}
                    />
                )}
            />
        </>
    );
};

export default AutocompleteField;
